import { useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";
import { Buttons } from "../../reusableUI/v2UI/Buttons";
import {
  BadgeCheck,
  BadgeDollarSign,
  Ban,
  CalendarRange,
  ChevronDown,
  CircleX,
  Copy,
  Eye,
  Lock,
  LockOpen,
  ReceiptText,
  Save,
  Share2,
  Star,
} from "lucide-react";
/* import { ButtonOptionsValidacion } from "./ButtonOptionsValidacion"; */

export const ButtonsBox = ({
  saveBudget,
  budgetPreview,
  duplicateBudget,
  shareBudget,
  approveBudget,
  setOpenAnular,
  handleTemplate,
  handleAddBuy,
  handleAddInvoice,
  handleVersiones,
  openCloseBudget,
  setOpenRequestValidation,
  setOpenRestartValidation,
  setOpenRejectValidate,
  setOpenValidate,
  handleAddProjections,
  openCreateFlow,
  budgetPreviewTest = null,
}) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  /*const { rules } = useSelector((state) => state.general); */
  const { access } = useSelector((state) => state.auth);
  const {
    id,
    total_gasto_r,
    validacion_estado,
    estado_negocio,
    estado_cierre,
    //validacion_id_regla,
  } = useSelector((state) => state.ppto.detail);

  return (
    <div className="">
      <div className="flex gap-2 overflow-x-auto scrollbar-hide whitespace-nowrap">
        {(estado_negocio === "por aprobar" || access.a24) &&
          estado_cierre !== "cerrado" &&
          estado_cierre !== "pausado" && (
            <Buttons
              name="Guardar"
              icon={<Save size={18} />}
              handleClick={saveBudget}
            />
          )}

        {id > 0 && id !== null && (
          <>
            {estado_negocio !== "anulado" && (
              <Buttons
                name="Vista previa"
                icon={<Eye size={18} />}
                handleClick={budgetPreview}
              />
            )}

            <Buttons
              name="Duplicar"
              icon={<Copy size={18} />}
              handleClick={duplicateBudget}
            />

            {estado_negocio !== "anulado" && (
              <Buttons
                name="Compartir"
                icon={<Share2 size={18} />}
                icon2={<ChevronDown size={16} />}
                handleClick={shareBudget}
              />
            )}

            {estado_negocio === "por aprobar" &&
              validacion_estado !== "por validar" &&
              validacion_estado !== "rechazada" && (
                <Buttons
                  name="Aprobar proyecto"
                  icon={<BadgeCheck size={18} />}
                  handleClick={() => approveBudget("approve")}
                />
              )}

            {estado_negocio === "aprobado" && (
              <Buttons
                name="Cancelar aprobación"
                icon={<CircleX size={18} />}
                handleClick={() => approveBudget("cancel")}
                disabled={total_gasto_r > 0 ? true : false}
              />
            )}

            {id > 0 &&
              estado_negocio !== "aprobado" &&
              estado_negocio !== "anulado" && (
                <Buttons
                  name="Anular"
                  icon={<Ban size={18} />}
                  handleClick={() => setOpenAnular(true)}
                />
              )}

            {estado_negocio === "aprobado" && (
              <Buttons
                name="Ejecutar gasto"
                icon={<BadgeDollarSign size={18} />}
                handleClick={handleAddBuy}
              />
            )}

            {estado_negocio === "aprobado" && (
              <Buttons
                name="Proyectar flujo"
                icon={<CalendarRange size={18} />}
                icon2={<ChevronDown size={16} />}
                handleClick={openCreateFlow}
              />
            )}

            {estado_negocio === "aprobado" && (
              <Buttons
                name="Facturar"
                icon={<ReceiptText size={18} />}
                handleClick={handleAddInvoice}
              />
            )}

            {estado_negocio === "aprobado" && (
              <Buttons
                name={
                  estado_cierre === "abierto"
                    ? "Cerrar proyecto"
                    : "Abrir proyecto"
                }
                icon={
                  estado_cierre === "abierto" ? (
                    <Lock size={18} />
                  ) : (
                    <LockOpen size={18} />
                  )
                }
                icon2={<ChevronDown size={16} />}
                handleClick={openCloseBudget}
              />
            )}

            {estado_negocio === "por aprobar" && (
              <>
                <Buttons
                  justIcon={true}
                  icon={<Star size={18} />}
                  handleClick={handleTemplate}
                  title="Guardar como plantilla"
                />

                {/* <Buttons
                  justIcon={true}
                  icon={<GitBranch size={18} />}
                  handleClick={handleVersiones}
                  title="Ver versiones del presupuesto"
                /> */}
              </>
            )}
          </>
        )}
      </div>

      {!isMobile ? (
        <div className="hidden">
          <Buttons
            justIcon={true}
            icon={<Star size={18} />}
            handleClick={handleTemplate}
            title="Guardar como plantilla"
          />
          {/* <Buttons
            justIcon={true}
            icon={<GitBranch size={18} />}
            handleClick={handleVersiones}
            title="Ver versiones del presupuesto"
          /> */}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
